const CELULAR_SIM = 'CelularSim';
const EMPRESTIMO_SIM = 'EmprestimoSim';
const CELULAR_SIM_LIGHT = 'CelularSimLight';
const APROVA_SIM = 'AprovaSim';
const ADIANTA_SIM = 'AdiantaSim';
const TOP_SIM = 'TopSim';
const DEU_TOP = 'DeuTop';

export { CELULAR_SIM, EMPRESTIMO_SIM, CELULAR_SIM_LIGHT, APROVA_SIM, ADIANTA_SIM, TOP_SIM, DEU_TOP };
